
import React from "react";
import { Routes, Route } from "react-router-dom";

import Footer from './components/Footer';
import Header from './components/Header';
import SliderComponent from './components/SliderComponent';
import Breadcrumb from './components/Breadcrumb';
import ClubCorredoresSection from "./components/ClubCorredoresSection";
import ScrollToTop from './components/ScrollToTop';

import MainPage from './pages/MainPage';
import AboutPage from './pages/AboutPage';
import OurTeamPage from './pages/OurTeamPage';
import NotFound from './pages/NotFound';
import ServicesPage from "./pages/ServicesPage";
import ResponsabilidadSocialPage from "./pages/ResponsabilidadSocialPage";
import FaqPage from "./pages/FaqPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import DynamicServicePage from "./pages/DynamicServicePage";
import BlogPage from "./pages/BlogPage";

function App() {
  return (
    <>
      <div className="page">
        <ScrollToTop />
        <Header />
        <Routes>
          {/* Home */}
          <Route path="/" element={<SliderComponent />} />
          <Route path="/nosotros" element={<Breadcrumb
            title="Sobre nosotros"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "nosotros" }
            ]} />} />

          <Route path="/equipo" element={<Breadcrumb
            title="Profesionales a tu servicio"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "equipo" }
            ]} />} />

          <Route path="/terminos" element={<Breadcrumb
            title="Términos y Condiciones"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "Términos y Condiciones" }
            ]} />} />

          <Route path="/privacidad" element={<Breadcrumb
            title="Políticas de privacidad"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "Politicas de Privacidad" }
            ]} />} />
          {/* 
          <Route path="/otros-servicios" element={<Breadcrumb
            title="Servicios Profesionales de salud"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "servicios" }
            ]} />} /> */}

          <Route path="/rsc" element={<Breadcrumb
            title="Responsabilidad Social Corporativa"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "R.S.C" }
            ]} />} />


          <Route path="/faq" element={<Breadcrumb
            title="Preguntas frecuentes"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "FAQ" }
            ]} />} />

          {/* Psicología breadcrumbs */}
          <Route path="/psicologia/adultos" element={<Breadcrumb
            title="Psicología para Adultos"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "psicología", link: "/psicologia" },
              { name: "adultos" }
            ]} />} />
          <Route path="/psicologia/adolescentes" element={<Breadcrumb
            title="Psicología para Adolescentes"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "psicología", link: "/psicologia" },
              { name: "adolescentes" }
            ]} />} />
          <Route path="/psicologia/deportistas" element={<Breadcrumb
            title="Psicología para Deportistas"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "psicología", link: "/psicologia" },
              { name: "deportistas" }
            ]} />} />
          <Route path="/psicologia/sesiones-grupales" element={<Breadcrumb
            title="Sesiones Grupales"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "psicología", link: "/psicologia" },
              { name: "sesiones grupales" }
            ]} />} />

          {/* Naturopatía Alimentaria breadcrumbs */}
          <Route path="/naturopatia-alimentaria/perdida-peso" element={<Breadcrumb
            title="Pérdida de Peso"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "naturopatía alimentaria", link: "/naturopatia-alimentaria" },
              { name: "pérdida de peso" }
            ]} />} />
          <Route path="/naturopatia-alimentaria/mantenimiento" element={<Breadcrumb
            title="Mantenimiento"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "naturopatía alimentaria", link: "/naturopatia-alimentaria" },
              { name: "mantenimiento" }
            ]} />} />
          <Route path="/naturopatia-alimentaria/soporte-online" element={<Breadcrumb
            title="Soporte Online"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "naturopatía alimentaria", link: "/naturopatia-alimentaria" },
              { name: "soporte online" }
            ]} />} />

          {/* Otros Servicios breadcrumbs */}
          <Route path="/otros-servicios/servicios-a-empresas" element={<Breadcrumb
            title="Servicios a Empresas"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "otros servicios", link: "/otros-servicios" },
              { name: "servicios a empresas" }
            ]} />} />
          <Route path="/otros-servicios/aumento-masa-muscular" element={<Breadcrumb
            title="Aumento de Masa Muscular"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "otros servicios", link: "/otros-servicios" },
              { name: "aumento de masa muscular" }
            ]} />} />
          <Route path="/otros-servicios/corredores" element={<Breadcrumb
            title="Corredores"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "otros servicios", link: "/otros-servicios" },
              { name: "corredores" }
            ]} />} />
          <Route path="/otros-servicios/opositores" element={<Breadcrumb
            title="Opositores"
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "otros servicios", link: "/otros-servicios" },
              { name: "opositores" }
            ]} />} />

          {/* Blog route */}
          <Route path="/blog" element={<Breadcrumb
            title="Nuestro Blog"
            description="Descubre nuestras últimas publicaciones sobre salud, bienestar y consejos de nuestros expertos. Síguenos en nuestras redes sociales para estar al día con contenido exclusivo, tips nutricionales, rutinas de ejercicio y mucho más."
            breadcrumb={[
              { name: "inicio", link: "/" },
              { name: "blog" }
            ]} />} />
        </Routes>

        <div className="site-main">

          <Routes>
            {/* Home */}
            <Route path="/" element={<MainPage />} />

            <Route path="/faq" element={<FaqPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/rsc" element={<ResponsabilidadSocialPage />} />
            <Route path="/privacidad" element={<PrivacyPage />} />
            <Route path="/terminos" element={<TermsPage />} />

            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/salud" element={<AboutPage />} />
            <Route path="/equipo" element={<OurTeamPage />} />
            <Route path="/club-corredores" element={<ClubCorredoresSection />} />


            <Route path="/otros-servicios" element={<ServicesPage title="Otros Servicios" whatsappnumber="+34621234462" path={"otros-servicios"} />} />
            <Route path="/otros-servicios/opositores" element={<DynamicServicePage  path={"opositores"} />} />
            <Route path="/otros-servicios/corredores" element={<DynamicServicePage  path={"corredores"} />} />
            <Route path="/otros-servicios/aumento-masa-muscular" element={<DynamicServicePage path={"aumento-masa-muscular"}  />} />
            <Route path="/otros-servicios/servicios-a-empresas" element={<DynamicServicePage  path={"servicios-a-empresas"} />} />

            <Route path="/naturopatia-alimentaria" element={<ServicesPage title="Naturopatía Alimentaria" whatsappnumber="+34621234462" path={"naturopatia-alimentaria"}  />} />
            <Route path="/naturopatia-alimentaria/perdida-peso" element={<DynamicServicePage path={"perdida-peso"} />} />
            <Route path="/naturopatia-alimentaria/mantenimiento" element={<DynamicServicePage path={"mantenimiento"} />} />
            <Route path="/naturopatia-alimentaria/soporte-online" element={<DynamicServicePage path={"soporte-online"} />} />

            <Route path="/psicologia" element={<ServicesPage title="Psicología" whatsappnumber="+34621234462" path={"psicologia"} />} />
            <Route path="/psicologia/adultos" element={<DynamicServicePage  path={"adultos"} />} />
            <Route path="/psicologia/sesiones-grupales" element={<DynamicServicePage  path={"sesiones-grupales"} />} />
            <Route path="/psicologia/adolescentes" element={<DynamicServicePage  path={"adolescentes"}  />} />
            <Route path="/psicologia/deportistas" element={<DynamicServicePage path={"deportistas"}  />} />
            <Route path="/psicologia/soporte-online" element={<DynamicServicePage path={"soporte-online"} />} />

            {/* Catch-al */}
            <Route path="*" element={<NotFound />} />
          </Routes>

        </div>

        <Footer />
        {/* back-to-top start */}
        <a id="totop" href="#top">
          <i className="icon-angle-up"></i>
        </a>
        {/* back-to-top end */}
        {/* This closing DIV comment matches your original HTML */}
      </div>
    </>
  );
}

export default App;
